import { AuthPolicyService } from '@core/auth/auth-policy.service';
import { AppGlobal } from '@core/utils/app';
import { filter } from 'rxjs';

/**
 * Ability to filter out an rxJS stream based on authentication policy around the auth id.
 * @param {string} authId
 * @returns {MonoTypeOperatorFunction<any>}
 */
export const ossFilterAuth = (authId: string) => {
    return filter(() => {
        const appInjector: any = AppGlobal.injector();
        const authPolicyService: AuthPolicyService = appInjector.get(AuthPolicyService) as AuthPolicyService;
        return authPolicyService.can(authId);
    });
};

